import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// material-ui
import { alpha, useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Chip,
  ClickAwayListener,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";

// third-party
import { FormattedMessage } from "react-intl";
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "ui-component/cards/MainCard";
import Transitions from "ui-component/extended/Transitions";
import useAuth from "hooks/useAuth";
import Axios from "axios";
// assets
import { IconLogout, IconUser } from "@tabler/icons";
import useConfig from "hooks/useConfig";
import { useSelector } from "store";
import { API_URL } from "config";

// ==============================|| PROFILE MENU ||============================== //

/*
 * One row of the menu: leading glyph and label.
 *
 * A component rather than copies because everything that makes it a row — the
 * radius, the icon's box, its height — is the same in each of them, and copies
 * stop agreeing the first time one of them is nudged. ScrollRail's PageHeader
 * exists in the same spirit.
 *
 * `active` is the page you are on. The blue pill, the blue glyph and the blue
 * label are NOT styled here — they are the theme's own `&.Mui-selected` rule
 * (themes/compStyleOverride.js), which already resolves to exactly the mock's
 * light-blue fill behind the app's blue. Declaring them again here would be a
 * second source of truth for the same colour.
 *
 * `aria-current="page"` rather than `aria-current="true"`: the active state is
 * derived from the route, so "page" is what it actually means.
 */
const MenuRow = ({ icon: Icon, labelId, onClick, active, sx }) => {
  const { borderRadius } = useConfig();

  return (
    <ListItemButton
      onClick={onClick}
      selected={active}
      aria-current={active ? "page" : undefined}
      sx={{
        borderRadius: `${borderRadius}px`,
        /*
         * The theme prints every ListItemText in `text.dark`, which is a fixed
         * colour — so on the blue `Mui-selected` row the label would stay black
         * while the glyph beside it turned blue. Inheriting lets the selected
         * colour reach the label too, which is what the mock shows.
         */
        "&.Mui-selected .MuiListItemText-primary": { color: "inherit" },
        ...sx,
      }}
    >
      <ListItemIcon>
        <Icon stroke={1.5} size="20px" aria-hidden="true" />
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography variant="body2">
            <FormattedMessage id={labelId} />
          </Typography>
        }
      />
    </ListItemButton>
  );
};

const ProfileSection = ({ fullname, email }) => {
  const theme = useTheme();
  const { borderRadius } = useConfig();
  const navigate = useNavigate();
  const flag = useSelector((state) => state.flag.value);
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  /*
   * Which row is "you are here", read off the route rather than tracked in
   * state. This replaces a `selectedIndex` that nothing ever set — both rows
   * carried `selected={selectedIndex === 4}` against an initial value of -1, so
   * it was permanently false.
   *
   * The whole /profile/* family is one page — follower, following, mygroup and
   * All_Members are tabs of it — so the row stays lit across all of them.
   */
  const { pathname } = useLocation();
  const onProfileRoute = pathname.startsWith("/profile/");

  /*
   * The panel's stand-in for a profile picture. Derived defensively: `fullname`
   * is built by string-concatenating two pieces of state that start empty, so on
   * the first render it is a single space.
   */
  const initials = (fullname || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  const handleNavigate = () => {
    navigate("/Calculator/PortfolioSizing");
    setOpen(false);
  };

  /*
   * The same destination the header's "Complete your profile details" chip opens,
   * so the two ways into a profile cannot disagree about where it lives. Like the
   * Calculator entry above, it closes the popover — it navigates in-app rather
   * than leaving the page, so the menu would otherwise stay open over the new one.
   */
  const handleNavigateProfile = () => {
    navigate("/profile/personal");
    setOpen(false);
  };

  /**
   * anchorRef is used on different components and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);
  const anchorRefcal = useRef(null);
  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = window.location.origin + "/login";
    } catch (err) {
      console.error(err);
    }
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };


  const prevOpen = useRef(open);
  var myDate = new Date();
  var hrs = myDate.getHours();
  var greet;
  const greetFun = () => {
    if (hrs < 12) greet = "Good Morning";
    else if (hrs >= 12 && hrs < 16) greet = "Good Afternoon";
    else if (hrs >= 17 && hrs <= 23) greet = "Good Evening";
    else greet = "Good Morning";
  };
  useEffect(() => {
    greetFun();
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const [ProfileImageFilePath, setProfileImageFilePath] =
    useState("profileDefult.png");
  const Usersid = window.localStorage.getItem("users");
  const val = JSON.parse(Usersid);
  const NId = val.id;
  const userId = NId;
  const memberId = NId;
  const [Badges, setBadge] = useState();
  useEffect(() => {
    const serviceToken = window.localStorage.getItem("serviceToken");
    Axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
    Axios.post(API_URL + "/api/view_member_profile", { memberId, userId }).then(
      (response) => {
        if (response.data.data.profile_details[0].imgurl !== "") {
          setProfileImageFilePath(response.data.data.profile_details[0].imgurl);
        } else {
          setProfileImageFilePath("profileDefult.png");
        }
        setBadge(response.data.data.profile_details[0].Badge);
      }
    );
  }, [flag]);

  const [getbordercolor, setbordercolor] = useState();
  const [getoutlinecolor, setoutlinecolor] = useState();
  //const [getbgcolor, setbgcolor]=useState();
  const [getbadgevalue, setbadgevalue] = useState();
  const [getborder, setborder] = useState();
  const [getoutline, setoutline] = useState();
  //const [getbadgesize, setbadgesize]=useState();

  useEffect(() => {
    if (Badges ? Badges === "Finisher" : "") {
      setbordercolor("#FFF");
      setoutlinecolor("#4CE5B3");
      setbadgevalue("F");
      setborder("2px solid");
      setoutline("3px solid");
    } else if (Badges ? Badges === "Rising Star" : "") {
      setbordercolor("#FFF");
      setoutlinecolor("#B54DE9");
      setbadgevalue("R");
      setborder("2px solid");
      setoutline("3px solid");
    } else if (Badges ? Badges === "Wizard" : "") {
      setbordercolor("#FFF");
      setoutlinecolor("#0496FF");
      setbadgevalue("W");
      setborder("2px solid");
      setoutline("3px solid");
    } else if (Badges ? Badges === "Crorepati" : "") {
      setbordercolor("#FFF");
      setoutlinecolor("#FCA311");
      setbadgevalue("C");
      setborder("2px solid");
      setoutline("3px solid");
    } else {
      setbordercolor("#FFF");
      setoutlinecolor("#FFF");
      setborder("0px solid");
    }
  });

  return (
    <>
      <Chip
        sx={{
          height: "48px",
          // The trigger is the picture alone now, so the chip is a circle around
          // it rather than a pill beside a glyph.
          width: "48px",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          transition: "all .2s ease-in-out",
          borderColor:
            theme.palette.mode === "dark"
              ? theme.palette.dark.main
              : theme.palette.primary.light,
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.dark.main
              : theme.palette.primary.light,
          '&[aria-controls="menu-list-grow"], &:hover': {
            borderColor: theme.palette.primary.main,
            background: `${theme.palette.primary.main}!important`,
            color: theme.palette.primary.light,
          },
          // The label held the settings glyph. Hidden rather than dropped so the
          // chip keeps the shape MUI gives it, with the avatar centred in it.
          "& .MuiChip-label": {
            display: "none",
          },
        }}
        icon={
          <Avatar
            src={API_URL + "/image/" + ProfileImageFilePath}
            sx={{
              ...theme.typography.mediumAvatar,
              margin: "0 !important",
              cursor: "pointer",
              borderRadius: "50%",
              border: getborder,
              outline: getoutline,
              outlineColor: getoutlinecolor,
              borderColor: "white",
            }}
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            color="inherit"
          />
        }
        variant="outlined"
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        color="primary"
      />

      <Popper
        placement="bottom"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 14],
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions in={open} {...TransitionProps}>
              <Paper>
                {open && (
                  <MainCard
                    border={false}
                    elevation={16}
                    content={false}
                    boxShadow
                    shadow={theme.shadows[16]}
                  >
                    {/* The design's header: who this menu belongs to. An inset
                        tinted panel rather than a full-bleed one, so it reads as
                        a card inside the menu instead of the menu's own header.
                        The tint is `alpha` over primary rather than
                        `primary.light` or `secondary.light` — those are near-white
                        and PINK respectively in dark mode, and among the six
                        preset themes they are teal, pink, amber, green and indigo,
                        none of which is a surface. */}
                    <Box sx={{ p: 1.5, pb: 0 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          p: 1.5,
                          borderRadius: `${borderRadius}px`,
                          bgcolor: alpha(
                            theme.palette.primary.main,
                            theme.palette.mode === "dark" ? 0.2 : 0.08
                          ),
                        }}
                      >
                        <Avatar
                          src={API_URL + "/image/" + ProfileImageFilePath}
                          alt={fullname}
                          sx={{
                            width: 52,
                            height: 52,
                            flexShrink: 0,
                            fontSize: "1.1rem",
                            fontWeight: 700,
                            bgcolor: "primary.main",
                            color: "primary.contrastText",
                            border: "2px solid",
                            borderColor: alpha(theme.palette.primary.main, 0.25),
                          }}
                        >
                          {initials}
                        </Avatar>
                        {/* `minWidth: 0` so a long name ellipsises instead of
                            pushing the avatar out of the panel. */}
                        <Box sx={{ minWidth: 0 }}>
                          <Typography variant="h4" noWrap>
                            {fullname}
                          </Typography>
                          {email?.length ? (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              noWrap
                            >
                              {email}
                            </Typography>
                          ) : null}
                        </Box>
                      </Box>
                      <Divider sx={{ mt: 1.5 }} />
                    </Box>
                    <PerfectScrollbar
                      style={{
                        height: "100%",
                        maxHeight: "calc(100vh - 250px)",
                        overflowX: "hidden",
                      }}
                    >
                      {/* Same 1.5 inset as the panel above, so the rows and the
                          panel share a left edge. */}
                      <Box sx={{ p: 1.5 }}>
                        <List
                          component="nav"
                          aria-label="Profile"
                          sx={{
                            width: "100%",
                            maxWidth: 350,
                            minWidth: 300,
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: "10px",
                            [theme.breakpoints.down("md")]: {
                              minWidth: "100%",
                            },
                            "& .MuiListItemButton-root": { mt: 0.5 },
                          }}
                        >
                          {/* Calculator — the only way into Portfolio Sizing from
                              this menu on a phone, which is why the design's
                              omission of it is not followed. */}
                          <ListItemButton
                            sx={{
                              borderRadius: `${borderRadius}px`,
                              display: { xs: "flex", md: "none" },
                            }}
                            onClick={handleNavigate}
                          >
                            <ListItemIcon>
                              <IconButton
                                variant="rounded"
                                sx={{
                                  ...theme.typography.commonAvatar,
                                  ...theme.typography.mediumAvatar,
                                  transition: "all .2s ease-in-out",
                                  background:
                                    theme.palette.mode === "dark"
                                      ? theme.palette.dark.main
                                      : theme.palette.secondary.light,
                                  color:
                                    theme.palette.mode === "dark"
                                      ? theme.palette.warning.dark
                                      : theme.palette.secondary.dark,
                                  '&[aria-controls="menu-list-grow"],&:hover': {
                                    background:
                                      theme.palette.mode === "dark"
                                        ? theme.palette.warning.dark
                                        : theme.palette.secondary.dark,
                                    color:
                                      theme.palette.mode === "dark"
                                        ? theme.palette.grey[800]
                                        : theme.palette.secondary.light,
                                  },
                                  ml: "-0.5rem",
                                }}
                                ref={anchorRefcal}
                                aria-haspopup="true"
                                color="inherit"
                              >
                                <CalculateIcon stroke={1.5} size="20px" />
                              </IconButton>
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography variant="body2">
                                  <FormattedMessage id="Calculater's" />
                                </Typography>
                              }
                            />
                          </ListItemButton>

                          <MenuRow
                            icon={IconUser}
                            labelId="Profile"
                            onClick={handleNavigateProfile}
                            active={onProfileRoute}
                          />

                          <Divider sx={{ my: 1 }} />

                          <MenuRow
                            icon={IconLogout}
                            labelId="logout"
                            onClick={handleLogout}
                          />
                        </List>
                      </Box>
                    </PerfectScrollbar>
                  </MainCard>
                )}
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};

export default ProfileSection;
